import type {ReactElement} from 'react';
import {useAppSelector} from '@/hooks';
import {selectFailedAiVideos, selectGeneratingAiVideoCount} from '@Components/poster-editor/poster-editor-reducer';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {MAX_CONCURRENT_AI_VIDEO_GENERATIONS} from '@Panels/ai-video-panel/ai-video-panel.library';
import {isMobile} from 'react-device-detect';
import styles from './ai-video-generation-limit-reached.module.scss';

interface AiVideoGenerationLimitReachedProps {
  isFullScreen?: boolean;
}

export function AiVideoGenerationLimitReached({isFullScreen = false}: AiVideoGenerationLimitReachedProps): ReactElement | null {
  const generatingCount = useAppSelector(selectGeneratingAiVideoCount);
  const failedVideos = useAppSelector(selectFailedAiVideos);

  if (generatingCount < MAX_CONCURRENT_AI_VIDEO_GENERATIONS) {
    return null;
  }

  return (
    <div
      className={`flexbox flex-center gap-2 spacing-p-2 bg-neutral-secondary-default ${isFullScreen && !isMobile ? `_position-absolute _full-width ${styles.topBanner}` : 'radius-8'} ${failedVideos.length > 0 ? 'spacing-m-b-3' : 'spacing-m-b-6'}`}
    >
      <Icon className="ct-neutral-primary" icon="icon-info" size={IconSize.SIZE_ICON_16} />
      <Text className="ct-neutral-primary" val={window.i18next.t('pmwjs_ai_video_limit_reached_try_again_soon')} size={TextSize.MD} />
    </div>
  );
}
